export interface TargetReachStepConfig {
    label: string;
    description: string;
    order: number;
}

export const TARGET_REACH_STEP_CONFIG: Record<string, TargetReachStepConfig> = {
    AUTHENTICATING: {
        label: 'Authenticating',
        description: 'Authenticating with services',
        order: 1
    },
    PARSING_INTENT: {
        label: 'Parsing intent',
        description: 'Analyzing your campaign brief with AI',
        order: 2
    },
    FINDING_CANDIDATE_EDGES: {
        label: 'Finding roads',
        description: 'Identifying high-value road segments',
        order: 3
    },
    GENERATING_ROUTES: {
        label: 'Generating routes',
        description: 'Building optimized driving routes',
        order: 4
    },
    SCORING_ROUTES: {
        label: 'Scoring routes',
        description: 'Estimating impressions for each route',
        order: 5
    },
    PERSISTING_ROUTE_PLANS: {
        label: 'Saving route plans',
        description: 'Persisting route plans to server',
        order: 6
    },
    GENERATING_EXPLANATION: {
        label: 'Generating explanation',
        description: 'Creating AI summary of route strategy',
        order: 7
    }
};

const TOTAL_ACTIVE_STEPS = 7;

export function getTargetReachStepConfig(step: string | undefined): TargetReachStepConfig | null {
    if (!step) {
        return null;
    }

    const upperStep = step.toUpperCase();
    return TARGET_REACH_STEP_CONFIG[upperStep] || null;
}

export function getTargetReachStepProgress(step: string | undefined): { current: number; total: number; percentage: number } | null {
    if (!step) {
        return null;
    }

    const upperStep = step.toUpperCase();
    const config = TARGET_REACH_STEP_CONFIG[upperStep];

    if (!config) {
        return null;
    }

    return {
        current: config.order,
        total: TOTAL_ACTIVE_STEPS,
        percentage: Math.round((config.order / TOTAL_ACTIVE_STEPS) * 100)
    };
}

export function isActiveTargetReachStep(step: string | undefined): boolean {
    if (!step) {
        return false;
    }

    const upperStep = step.toUpperCase();
    return TARGET_REACH_STEP_CONFIG[upperStep] !== undefined;
}
